import neff from 'neff/cjs'
import thunk from 'redux-thunk' // needed for async actions
import { createLogger } from 'redux-logger' // Redux middleware for console.logging actions
import reduxAnalytics from 'redux-analytics'
import {
  trackError,
  trackAction,
  trackLink,
  trackLinkWithData,
  trackImpression,
  startCPLTracking,
  setPersistentData,
} from '../../lib/analytics/fpti'
import { routerMiddleware } from 'connected-react-router'
import history from '../stores/configureHistory'
import { INSTRUMENTATION_TYPES } from '../constants'
import hooks from './hooks'
import { actionHistory } from './action-history'

const SHOW_LOGGER = neff.isEnabled('verbose-logging')
const logger = createLogger({
  level: 'info',
  collapsed: true,
  titleFormatter: (action, time, took) =>
    `(p2p) action @ ${time} ${action.type} (in ${took.toFixed(2)} ms)`,
  predicate: (getState, action) => SHOW_LOGGER, // show or hide logs
})

const analytics = reduxAnalytics(({ type, payload = {} }) => {
  switch (type) {
    case INSTRUMENTATION_TYPES.ERROR:
      trackError(payload.error)
      break
    case INSTRUMENTATION_TYPES.ACTION:
      trackAction(payload.linkName)
      break
    case INSTRUMENTATION_TYPES.ACTION_WITH_DATA:
      trackLinkWithData(payload.linkName, payload.data, payload.trackType) // NOSONAR
      if (payload.nextPageGroup) {
        startCPLTracking(payload.data) // NOSONAR
      }
      if (payload.persistKey) {
        setPersistentData(payload.persistKey, payload.data)
      }
      break
    case INSTRUMENTATION_TYPES.PAGE_CHANGE:
      trackLink(
        payload.linkName,
        'link',
        payload.transactionDetailsLinks,
        payload.data
      )
      if (payload.nextPageGroup) {
        startCPLTracking() // NOSONAR
      }
      break
    case INSTRUMENTATION_TYPES.IMPRESSION:
      trackImpression(payload.data) // NOSONAR
      break
    default:
    // we weren't specifying what type of analytics to do, so don't track anything
  }
})

// Redux middleware for dispatching redux actions to navigate via react-router
const router = routerMiddleware(history)

export default [thunk, logger, router, analytics, hooks, actionHistory]
